module.exports = __webpack_public_path__ + "static/img/ba-icon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ba-icon.png
// module id = GO5g
// module chunks = 16